<template>
  <div class="d-flex">
    <div class="pr-2">
      <div class="activity-dp rounded-circle bg-light p-2 text-center">
        {{user.first_name.charAt(0)}}{{user.last_name.charAt(0)}}
      </div>
    </div>
    <div>
      <p class="mb-0">
        {{ getActivityMessage(item) }}
        <!-- {{item.causer.first_name}} {{item.causer.last_name}} {{item.description}} {{item.subject.name}} from {{ item.properties.old }} to {{ item.properties.attributes }} -->
      </p>
      <p class="text-muted activity-time mb-0">{{moment(item.updated_at).format('LLL')}}</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Activity',
  props: ['item', 'user'],
  methods: {
    moment,
    getActivityMessage(item) {
      let itemDetails = ''
      if (item.subject) {
        if (item.subject.name) {
          itemDetails = item.subject.name
        } else {
          itemDetails = item.message
        }
      } else if (!item.subject && item.message) {
        itemDetails = item.message
      } else {
        itemDetails = ''
      }
      return `${item.causer.first_name} ${item.causer.last_name} ${item.description.toUpperCase()} ${item.log_name} ${itemDetails}.`
    },
  },
}
</script>
<style lang="scss" scoped>
.activity-time{
  font-size: 0.8rem;
}
.activity-dp {
  width: 35px;
  height: 35px;
}
</style>
